module.exports = __webpack_public_path__ + "img/armaBoca2.5523135c.jpg";